import { EvaluationAnalysisInterface } from 'app/assessment/evaluation/models/evaluation-analysis.model';
import { Assessment, AssessmentInterface } from 'app/assessment/models/assessment.model';
import { ReviewInterface } from 'app/assessment/models/review.model';


export interface EvaluationInterface extends AssessmentInterface {
  analysis?: EvaluationAnalysisInterface;
  reviews?: ReviewInterface[];
  lastUpdated?: Date;
  printPages?: string[];
}

export class Evaluation extends Assessment implements EvaluationInterface {
  public analysis?: EvaluationAnalysisInterface;
  public reviews?: ReviewInterface[];
  public lastUpdated?: Date;
  public printPages?: string[];

  constructor({
    analysis = undefined,
    reviews = undefined,
    lastUpdated = undefined,
    printPages = undefined,
    }: EvaluationInterface) {
    super(arguments[0]);
    this.analysis = analysis;
    this.reviews = reviews;
    this.lastUpdated = lastUpdated;
    this.printPages = printPages ? printPages : [];
  }
}
